import { useState } from "react";
import { Form } from "react-bootstrap";
import { create } from "../../services/upload-files.service";

const CreateRole = () => {
    const [formData, setFormData] = useState({})
    const [validationErrors, setValidationErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateFormFields(formData);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
        } else {
            try {
                const res = await create(formData, 'role');

                if (res.success && res.data.affectedRows > 0) {
                    console.log("created role successfully");
                } else {
                    setValidationErrors({ err: 'Please Enter a Valid Role Name' });
                }
            } catch (error) {
                setValidationErrors({ err: 'An Error Occurred. Please Try Again Later.' });
            }
            setFormData({});
            // setValidationErrors({});
        }
    };

    const validateFormFields = (formData) => {
        const errors = {};
        if (!formData.role_name || formData.role_name.trim() === '') {
            errors.role_name = 'Please Enter Role Name';
        }

        return errors;
    };

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">Create Role</h1>
                </div>

                <div className='row'>
                    <div className='col-4'>
                        <div className='editprofile'>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="rolename">
                                    <Form.Label>Role Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.role_name ? formData.role_name : ""}
                                        name="role_name"
                                        onChange={handleInputChange} />
                                    {validationErrors.role_name && <div className="error login-error">{validationErrors.role_name}</div>}
                                </Form.Group>
                                <button class="btn btn-primary btn-add mb-3" type="submit">  Save</button>
                                 <button class="btn btn-primary btn-add mb-3" type="submit">  Edit</button>
                                  <button class="btn btn-primary btn-add mb-3" type="submit">  Delete</button>
                            </Form>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )

}

export default CreateRole;